import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BuildingIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M12.0007 2.10564L5.09558 7.2392H18.9057L12.0007 2.10564ZM10.9608 0.341114C11.5753 -0.113705 12.426 -0.113705 13.0362 0.341114L19.5632 5.19252V2.18566C19.5632 1.62556 20.0229 1.17495 20.5944 1.17495C21.1659 1.17495 21.6257 1.62556 21.6257 2.18566V6.72542L22.5925 7.44555C22.9448 7.70665 23.0866 8.16147 22.9448 8.57418C22.803 8.98689 22.412 9.26062 21.9694 9.26062H2.03191C1.58933 9.26062 1.19401 8.98267 1.05651 8.57418C0.919015 8.16568 1.05651 7.71087 1.40886 7.44555L10.9608 0.341114ZM10.6257 5.21778C10.6257 4.86038 10.7705 4.5176 11.0284 4.26488C11.2862 4.01215 11.636 3.87017 12.0007 3.87017C12.3653 3.87017 12.7151 4.01215 12.9729 4.26488C13.2308 4.5176 13.3757 4.86038 13.3757 5.21778C13.3757 5.57519 13.2308 5.91796 12.9729 6.17069C12.7151 6.42342 12.3653 6.5654 12.0007 6.5654C11.636 6.5654 11.2862 6.42342 11.0284 6.17069C10.7705 5.91796 10.6257 5.57519 10.6257 5.21778Z"
            fill="currentColor"
         />
         <path
            d="M10.9258 12.4403C10.9258 11.8471 11.4067 11.3661 12 11.3661C12.5933 11.3661 13.0742 11.8471 13.0742 12.4403V22.9258C13.0742 23.519 12.5933 24 12 24C11.4067 24 10.9258 23.519 10.9258 22.9258V12.4403Z"
            fill="currentColor"
         />
         <path
            d="M15.2226 12.4403C15.2226 11.8471 15.7035 11.3661 16.2968 11.3661C16.8901 11.3661 17.371 11.8471 17.371 12.4403V22.9258C17.371 23.519 16.8901 24 16.2968 24C15.7035 24 15.2226 23.519 15.2226 22.9258V12.4403Z"
            fill="currentColor"
         />
         <path
            d="M19.5196 12.4403C19.5196 11.8471 20.0006 11.3661 20.5938 11.3661C21.1871 11.3661 21.6681 11.8471 21.6681 12.4403V22.9258C21.6681 23.519 21.1871 24 20.5938 24C20.0006 24 19.5196 23.519 19.5196 22.9258V12.4403Z"
            fill="currentColor"
         />
         <path
            d="M2.05282 13.4719C1.47136 13.4719 1 13.0006 1 12.4191C1 11.8376 1.47136 11.3663 2.05282 11.3663L21.9472 11.3663C22.5286 11.3663 23 11.8376 23 12.4191C23 13.0006 22.5286 13.4719 21.9472 13.4719L2.05282 13.4719Z"
            fill="currentColor"
         />
         <path
            d="M2.05282 24C1.47136 24 1 23.5286 1 22.9472C1 22.3657 1.47136 21.8943 2.05282 21.8943H21.9472C22.5286 21.8943 23 22.3657 23 22.9472C23 23.5286 22.5286 24 21.9472 24H2.05282Z"
            fill="currentColor"
         />
         <path
            d="M6.62898 12.4403C6.62898 11.8471 7.10993 11.3661 7.7032 11.3661C8.29648 11.3661 8.77742 11.8471 8.77742 12.4403V22.9258C8.77742 23.519 8.29648 24 7.7032 24C7.10993 24 6.62898 23.519 6.62898 22.9258V12.4403Z"
            fill="currentColor"
         />
         <path
            d="M2.33195 12.4403C2.33195 11.8471 2.81289 11.3661 3.40617 11.3661C3.99944 11.3661 4.48039 11.8471 4.48039 12.4403V22.9258C4.48039 23.519 3.99944 24 3.40617 24C2.81289 24 2.33195 23.519 2.33195 22.9258V12.4403Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default BuildingIcon
